import * as z from "zod";

export const hideInvisibleRateNameCharsAllowed = {
  name: "hideInvisibleRateNameCharsAllowed" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ allowed: z.boolean(), reason: z.string().optional() }),
};
